import React, { Component } from "react";
import { NavLink, withRouter } from 'react-router-dom';
import { BoxDanger, MnemoLoading, SupportoTecnico, Title } from "components/misc";
import { CourseHelper, dateHelper, learningService, networkErrorHelper } from "libs";
import { Icon } from "design-react-kit";
import { COMPETITION_CLASS_TITLE, COMPETITION_CLASS_TITLE_BEFORE2025, ROUTES } from "const";
import { rc30ExamService } from "libs/api/rc30ExamService";

class RC30CertificationRequest extends Component {

    state = {
        loading: true,
        loadingError: false,
        course: 0,
        userCourse: 0,
        rCode: '',
        examDone: false
    };

    goBack() {
        window.history.back();
    }

    componentDidMount() {

        const { rCode } = this.props.match.params;
        this.loadRemote(rCode);
    }

    loadRemote(rCode) {

        learningService
            .courseDashboard(rCode)
            .then(({ data }) => {

                const { course, userCourse } = data.payload;
                this.setState({ course, userCourse, rCode });

                rc30ExamService.myExamDone(rCode)
                    .then(({ data }) => {

                        const { examDone } = data.payload;
                        this.setState({ loading: false, examDone, loadingError: false });
                    })
                    .catch(error => {

                        if (!networkErrorHelper.is404(error)) {
                            networkErrorHelper.notify(error);
                        }

                        this.setState({ rCode, loading: false, loadingError: true });
                    });
            })
            .catch(error => {

                if (!networkErrorHelper.is404(error)) {
                    networkErrorHelper.notify(error);
                }

                this.setState({ loading: false, loadingError: true });
            });
    }

    render() {

        const { loading, loadingError, rCode, userCourse, examDone, course } = this.state;
        if (loading) return (<MnemoLoading></MnemoLoading>);
        if (loadingError) {
            return (<BoxDanger className="mt-4">
                Si è verificato un errore durante il caricamento della pagina,
                <br /><SupportoTecnico />
            </BoxDanger>);
        }

        const dateExam = dateHelper.toITDate(examDone.date);
        const titleCC = course.title;
        const titleCC_exart13_before_2025 = (userCourse.pluginConfig.competitionClassTitle && userCourse.pluginConfig.competitionClassTitle.length > 0) ? userCourse.pluginConfig.competitionClassTitle : COMPETITION_CLASS_TITLE_BEFORE2025[userCourse.pluginConfig.competitionClass];
        const titleCC_exart13 = (userCourse.pluginConfig.competitionClassTitle && userCourse.pluginConfig.competitionClassTitle.length > 0) ? userCourse.pluginConfig.competitionClassTitle : COMPETITION_CLASS_TITLE[userCourse.pluginConfig.competitionClass];
        let courseTypeVC = "Percorso di completamento 30 CFU destinato ai vincitori del concorso ai sensi dell'art.13, comma 2, del decreto legislativo 13 aprile 2017 n. 59(allegato 2 del D.P.C.M. 4 agosto 2023)";
        let courseTypeManifesto = "Percorsi di formazione iniziale di 30 CFU di cui al D.P.C.M.4 agosto 2023 (ALL. 2)";
        if (CourseHelper.isUM36VC(userCourse.courseCode) || CourseHelper.isIUL36VC(userCourse.courseCode)) {
            courseTypeVC = "Percorso di completamento 36 CFU/CFA di cui all'art.18 bis, comma 4, secondo periodo, del decreto legislativo 13 aprile 2017 n. 59, destinato a coloro i quali, entro il 31 ottobre 2022, abbiano conseguito i 24 CFU/CFA (allegato 5 del D.P.C.M.)";
        }

        if (CourseHelper.is60CFU(userCourse.courseCode)) {
            courseTypeManifesto = "Percorsi di formazione iniziale di 60 CFU di cui al D.P.C.M.4 agosto 2023 (ALL. 1)";
        }

        if ((userCourse.aa < 2025) && CourseHelper.isExArt13(userCourse.courseCode)) {
            return (<>
                <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`} className="mx-5 btn btn-outline-primary float-right"><Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO</NavLink>
                <Title >Percorso di formazione iniziale di 30 CFU di cui all’ art. 13 del D.P.C.M. 4 agosto 2023</Title>
                <hr />
                <p>Facendo seguito al corso da Lei frequentato ed alla prova finale sostenuta, nell'attesa che l'Università emetta la certificazione finale a tutti i corsisti(ad eccezione degli iscritti con riserva poichè in possesso di abilitazione conseguita all'estero), si riportano i dati utili all'autocertificazione:</p>
                <ul>
                    <li><b>Classe di Concorso</b>: {userCourse.pluginConfig.competitionClass} - {titleCC_exart13_before_2025}</li>
                    <li><b>Procedura abilitante</b>: Abilitazione conseguita attraverso la frequenza del percorso universitario e accademico di formazione iniziale di 30 CFU, di cui all’art. 13, comma 2, e all’art. 2-ter, commi 4 e 4-bis, del decreto Legislativo 13 aprile 2017, n. 59</li>
                    <li><b>Voto Finale</b>: {examDone.voteFinal}/10</li>
                    <li><b>Data di Conseguimento</b>: {dateExam}</li>
                    <li><b>Istituzione</b>: {course.institute}</li>
                </ul>
            </>)
        } else if (userCourse.aa > 2024 && CourseHelper.isTchaikovsky(userCourse.courseCode)) {
            return (<>
                <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`} className="mx-5 btn btn-outline-primary float-right"><Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO</NavLink>
                <Title >Percorso di formazione iniziale di 30 CFA di cui all’ art. 13 del D.P.C.M. 4 agosto 2023</Title>
                <hr />
                <p>Facendo seguito alla partecipazione al percorso formativo e al superamento della relativa prova finale, nelle more del rilascio della certificazione conclusiva da parte del Conservatorio, previsto nelle prossime settimane, si riportano di seguito i dati necessari ai fini dell’autocertificazione del titolo conseguito:</p>
                <ul>
                    <li><b>Classe di Concorso</b>:{userCourse.pluginConfig.competitionClass} - {titleCC_exart13}</li>
                    <li><b>Procedura abilitante</b>: Abilitazione all'insegnamento della classe di concorso {userCourse.pluginConfig.competitionClass} - {titleCC_exart13} - Percorso di formazione iniziale di 30 CFA di cui all’ art. 13 del D.P.C.M. 4 agosto 2023</li>
                    <li><b>Voto Finale</b>: {examDone.voteFinal}/10</li>
                    <li><b>Data di Conseguimento</b>: {dateExam}</li>
                    <li><b>Istituzione</b>: {course.institute}</li>
                </ul>
            </>)
        } else if (userCourse.aa > 2024 && CourseHelper.isExArt13(userCourse.courseCode)) {
            return (<>
                <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`} className="mx-5 btn btn-outline-primary float-right"><Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO</NavLink>
                <Title >Percorso di formazione iniziale di 30 CFU di cui all’ art. 13 del D.P.C.M. 4 agosto 2023</Title>
                <hr />
                <p>Facendo seguito alla partecipazione al percorso formativo e al superamento della relativa prova finale, nelle more del rilascio della certificazione conclusiva da parte dell’Università, previsto nelle prossime settimane, si riportano di seguito i dati necessari ai fini dell’autocertificazione del titolo conseguito:</p>
                <ul>
                    <li><b>Classe di Concorso</b>:{userCourse.pluginConfig.competitionClass} - {titleCC_exart13}</li>
                    <li><b>Procedura abilitante</b>: Abilitazione all'insegnamento della classe di concorso {userCourse.pluginConfig.competitionClass} - {titleCC_exart13} - Percorso di formazione iniziale di 30 CFU di cui all’ art. 13 del D.P.C.M. 4 agosto 2023</li>
                    <li><b>Voto Finale</b>: {examDone.voteFinal}/10</li>
                    <li><b>Data di Conseguimento</b>: {dateExam}</li>
                    <li><b>Istituzione</b>: {course.institute}</li>
                </ul>
            </>)
        } else if (userCourse.aa > 2024 && CourseHelper.isTchaikovsky(userCourse.courseCode)) {
            return (<>
                <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`} className="mx-5 btn btn-outline-primary float-right"><Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO</NavLink>
                <Title >Percorso di formazione iniziale di 30 CFA di cui all’ art. 13 del D.P.C.M. 4 agosto 2023</Title>
                <hr />
                <p>Facendo seguito alla partecipazione al percorso formativo e al superamento della relativa prova finale, nelle more del rilascio della certificazione conclusiva da parte del Conservatorio, previsto nelle prossime settimane, si riportano di seguito i dati necessari ai fini dell’autocertificazione del titolo conseguito:</p>
                <ul>
                    <li><b>Classe di Concorso</b>:{userCourse.pluginConfig.competitionClass} - {titleCC_exart13}</li>
                    <li><b>Procedura abilitante</b>: Abilitazione all'insegnamento della classe di concorso {userCourse.pluginConfig.competitionClass} - {titleCC_exart13} - Percorso di formazione iniziale di 30 CFA di cui all’ art. 13 del D.P.C.M. 4 agosto 2023</li>
                    <li><b>Voto Finale</b>: {examDone.voteFinal}/10</li>
                    <li><b>Data di Conseguimento</b>: {dateExam}</li>
                    <li><b>Istituzione</b>: {course.institute}</li>
                </ul>
            </>)
        } else if (CourseHelper.is30CFU(userCourse.courseCode) || CourseHelper.is60CFU(userCourse.courseCode)) {
            return (<>
                <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`} className="mx-5 btn btn-outline-primary float-right"><Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO</NavLink>
                <Title >Esito Prova Finale</Title>
                <hr />
                <p>Facendo seguito alla partecipazione al percorso formativo e al superamento della relativa prova finale, nelle more del rilascio della certificazione conclusiva da parte dell’Università, previsto nelle prossime settimane, si riportano di seguito i dati necessari ai fini dell’autocertificazione del titolo conseguito:</p>
                <ul>
                    <li><b>Classe di Concorso</b>:  {titleCC}</li>
                    <li><b>Procedura abilitante</b>: Abilitazione all'insegnamento della classe di concorso  {titleCC} - {courseTypeManifesto}</li>
                    <li><b>Voto Finale</b>: {examDone.voteFinal}/10</li>
                    <li><b>Data di Conseguimento</b>: {dateExam}</li>
                    <li><b>Istituzione</b>: {course.institute}</li>
                </ul>
                <br />
            </>)
        } else if (CourseHelper.isVC(userCourse.courseCode)) {
            return (<>
                <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`} className="mx-5 btn btn-outline-primary float-right"><Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO</NavLink>
                <Title >Esito Prova Finale</Title>
                <hr />
                <p>Facendo seguito alla partecipazione al percorso formativo e al superamento della relativa prova finale, nelle more del rilascio della certificazione conclusiva da parte dell’Università, previsto nelle prossime settimane, si riportano di seguito i dati necessari ai fini dell’autocertificazione del titolo conseguito:</p>
                <ul>
                    <li><b>Classe di Concorso</b>:  {titleCC}</li>
                    <li><b>Procedura abilitante</b>: Abilitazione all'insegnamento della classe di concorso  {titleCC} -  {courseTypeVC}</li>
                    <li><b>Voto Finale</b>: {examDone.voteFinal}/10</li>
                    <li><b>Data di Conseguimento</b>: {dateExam}</li>
                    <li><b>Istituzione</b>: {course.institute}</li>
                </ul>
                <br />
            </>)
        }
        else {
            return (<>
                <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`} className="mx-5 btn btn-outline-primary float-right"><Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO</NavLink>
                <Title ></Title>
                <hr />

                <p>Facendo seguito al corso da Lei frequentato ed alla prova finale sostenuta, nell'attesa che l'Università emetta la certificazione finale a tutti i corsisti, si riportano i dati utili all'autocertificazione:</p>
                <ul>
                    <li><b>Voto Finale</b>: {examDone.voteFinal}/10</li>
                    <li><b>Data di Conseguimento</b>: {dateExam}</li>
                    <li><b>Istituzione</b>: {course.institute}</li>
                </ul>
            </>)
        }
    }
}

export default withRouter(RC30CertificationRequest);